export default "__VITE_ASSET___VZrAoQ7__"